import { useTranslation } from 'react-i18next';
import { MockAppFrame } from '../mock-app-frame.jsx';
import { TagsCard } from '../tags-card.jsx';

/**
 * Tags use-case mockup: the transactions feed with tag pills, plus the
 * tag-and-filter note.
 * @returns {JSX.Element}
 */
export function TagsScreen() {
	const { t } = useTranslation();
	return (
		<>
			<MockAppFrame>
				<TagsCard />
			</MockAppFrame>
			<div className="use-case-callout card">
				<h3>{t('usecase.tags.filter.title')}</h3>
				<p>{t('usecase.tags.filter.body')}</p>
			</div>
		</>
	);
}
